import './../../css/mk-brand.css';

import {useState, useEffect} from "react";


function JoinUsPanel() {
    useEffect(() => {}, );
    return (
        <div id="join-us-panel" className="text-white body-font">
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-col text-center w-full mb-12">
                    <h1 className="sm:text-5xl text-4xl mb-4 text-brand">Join Us</h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Let us know why you are interested in metaKitchen and what skills you would bring to the team.</p>
                </div>
                <div className="lg:w-1/2 md:w-2/3 mx-auto">
                    <div className="flex flex-wrap -m-2">
                        <div className="p-2 w-full">
                            <button onClick={()=>{window.open('mailto:admin@metakitchen.io?subject=Web Inquiry');}}
                                className="bg-brand flex mx-auto text-white text-brand-text border-0 py-2 px-8 hover:bg-gray-600 focus:outline-none rounded-full text-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-brand duration-300"
                            >
                                Send us an Email
                            </button>
                        </div>
                        <div className="p-2 w-full pt-8 mt-8 border-t border-gray-500 text-center">
                            <a className="text-white underline" href="mailto:admin@metakitchen.io">Or click/copy this link to use your default email application.</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default JoinUsPanel;